import type { Story } from '@/domain/story'
import type { StoryRepository } from '@/repositories/StoryRepository'
import { seedStories } from '@/data/seed/stories'

export class LocalStoryRepository implements StoryRepository {
  async list(): Promise<Story[]> {
    return seedStories
  }

  async getById(id: string): Promise<Story | null> {
    return seedStories.find((s) => s.id === id) ?? null
  }
}
